import { Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import Icon from 'components/Icon'
import { ObservabilityToolCustomIcon } from 'components/status-checks/common/ObservabilityToolCustomIcon'
import { ObservabilityToolIcon } from 'components/status-checks/common/ObservabilityToolIcon'
import {
  getMonitorPageUrl,
  isCustomStatusCheck
} from 'components/status-checks/status-checks-form-utils'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { muiTheme } from 'mui-theme'
import theme from 'theme'
import { type StatusCheck } from 'types/api/status-checks/status-check'
import { getIntegrationTypeFromObservabilityToolTypeAndDomain } from 'utils/team-external-integrations/team-external-integrations-util'

export const StatusCheckListNameCell: React.FC<{
  statusCheck: StatusCheck
}> = ({ statusCheck }) => {
  const { domain, observabilityToolType } =
    statusCheck.teamExternalIntegration ?? {}

  const integrationType =
    observabilityToolType &&
    getIntegrationTypeFromObservabilityToolTypeAndDomain(
      observabilityToolType,
      domain
    )

  const statusChecksUrls = getStatusChecksUrls()

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', columnGap: 2, maxWidth: '100%' }}
    >
      <Link to={statusChecksUrls.edit(statusCheck.identifier)}>
        {isCustomStatusCheck(statusCheck) ? (
          <ObservabilityToolCustomIcon />
        ) : (
          <ObservabilityToolIcon statusCheck={statusCheck} />
        )}
      </Link>
      <Stack sx={{ maxWidth: `calc(100% - ${muiTheme.spacing(5)})` }}>
        <TruncatedTextWithTooltip
          data-test-status-check-list-row-name={statusCheck.name}
          tooltipProps={{
            title: statusCheck.name
          }}
        >
          <Link to={statusChecksUrls.edit(statusCheck.identifier)}>
            {statusCheck.name}
          </Link>
        </TruncatedTextWithTooltip>
        {statusCheck.endpointConfiguration?.url && (
          <Stack
            direction="row"
            sx={{
              alignItems: 'baseline',
              columnGap: 1
            }}
          >
            <TruncatedTextWithTooltip
              color={theme.colors.steel[1]}
              tooltipProps={{
                title: statusCheck.endpointConfiguration.url
              }}
              variant="caption"
            >
              {statusCheck.endpointConfiguration.url}
            </TruncatedTextWithTooltip>
            {statusCheck.rawEndpointConfiguration?.url && integrationType && (
              <MUIExternalLink
                href={getMonitorPageUrl(
                  statusCheck.rawEndpointConfiguration.url,
                  integrationType
                )}
              >
                <Icon icon="arrowUpRightFromSquare" />
              </MUIExternalLink>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
